export default __webpack_public_path__ + "img/524ccfa6ae37e48a42b27aa13e5e0d8d.svg";